export const INTERVIEW_TYPE = {
  HiringAuthority: 'HiringAuthority',
  Candidate: 'Candidate'
};

export const INTERVIEW_TYPES = [INTERVIEW_TYPE.HiringAuthority, INTERVIEW_TYPE.Candidate];
